import httpHelper from '../../../../utils/httpHelper';
const APP_CONFIG = JSON.parse(localStorage.getItem('appConfig'));

const service = {
  async getLocation(coordinate) {
    const endPoint = `gh/reverse?coordinate=${coordinate}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },
  async getAllTransportationWithSearch(params) {
    const endPoint = `kv/transportation/search`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      params,
      'Bearer',
    );
    return result;
  },
  async findAllByMCodeAndMtId(transportationId) {
    const endPoint = `location-data/findAllByMCodeAndMtId?mCode=KV&mtId=${transportationId}`;
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endPoint,
      {},
      'Bearer',
    );
    return result;
  },
  async getCardEventswithSearch(params) {
    const endpoint = 'kv/card-event/search';
    const result = await httpHelper.makeGetRequest(
      APP_CONFIG,
      endpoint,
      params,
      'Bearer',
    );
    return result;
  },
};

export default service;
